import { cms } from "./index"

const getEvents = () => {
  return cms.get("/endurance-agenda")
}

export default getEvents
